import { useReducer } from "react";
import { uuidv4 } from "../utils/Helper";

function outputsReducer(state, action) {
  switch (action.type) {
    case "ADD": {
      return [...state, action.payload];
    }
    case "CLEAR": {
      return [];
    }
    default: {
      throw new Error(`Unhandled type: ${action.type}`);
    }
  }
}

const NOT_SUPPORTED = ["group", "dir", "assert", "table"];

export default function useOutputs() {
  const [outputs, dispatch] = useReducer(outputsReducer, []);

  function add(flag, ...log) {
    if (flag === "clear") {
      clear();
      return;
    }

    let item = {
      id: uuidv4(),
      value: log.length > 1 ? log.join(" ") : log[0],
      flag,
    };

    // TODO: fix this horrible hack 😅. Shame !!!
    if (typeof(item.value) === 'string' && item.value.includes("Critical dependency")) {
      return;
    }

    item.value = NOT_SUPPORTED.includes(flag)
      ? `console.${flag}: Not supported yet 😭`
      : item.value;

    dispatch({ type: "ADD", payload: item });
  }

  function clear() {
    dispatch({ type: "CLEAR" });
  }

  return { outputs, add, clear };
}
